import React from 'react';

import {updateFilterForSingleSelection, fixedPopularFilter} from '../../utils/filter-utils';

import {ArrayTogglerBehaviorTypes} from '../../../../hooks/useArrayToggler';
import {sendEvarData} from '@ibibo/analytics';

import CheckBoxList from '../../../../../stories/components/hotels/common/CheckBoxList/CheckBoxList';

const PopularFilter = ({updateFilter, appliedFilters, cityData}) => {
  const onFilterSelect = (_, itemUnderAction, isSelected) => {
    updateFilter(updateFilterForSingleSelection(itemUnderAction.fd, appliedFilters));
    sendEvarData({
      prop54: `FilterApplied|${itemUnderAction.n}`,
    }, true)
  };

  let setData = [];
  if(cityData && cityData.co !== 'india'){
    setData = [
      // {n: 'MySafety', fd: {gs: 1}},
      {n: 'Free Cancellation', fd: {fc: 1}},
      // {n: 'Pay At Hotel', fd: {pah: 1}},
      {n: 'Free Breakfast', fd: {ibf: 1}}, // fbfi
    ]
  } else{
    setData = [
      {n: 'MySafety', fd: {gs: 1}},
      {n: 'Free Cancellation', fd: {fc: 1}},
      // {n: 'Pay At Hotel', fd: {pah: 1}},
      {n: 'Free Breakfast', fd: {ibf: 1}}, // fbfi
    ]
  }

  return (
    <CheckBoxList
      name="POPULAR FILTERS"
      data={setData}
      lookup={item => item.n}
      type={ArrayTogglerBehaviorTypes.multiSelect}
      renderItem={item => <>{item.n}</>}
      actionHandler={onFilterSelect}
      defaultState={Object.keys(appliedFilters)
        .filter(
          item => ['gs', 'fbfi', 'ibf', 'pah', 'fc'].indexOf(item) > -1 && appliedFilters[item] === 1,
        )
        .map(item => {
          let arg = {};
          arg[item] = appliedFilters[item];
          return {n: fixedPopularFilter[item], fd: {...arg}};
        })}
      resetHandlerProp={() => {
        updateFilter({gs: 0, ibf: 0, fc: 0, pah: 0}); // fbfi
      }}
    />
  );
};

export default React.memo(PopularFilter);
